import { DefaultPagination } from '../../store/modules/page/Pagination';
import { QueryParams } from './query-params';

/**
 * @class PaginationParams
 * @classdesc This class represents query params
 * for pagination case
 */
export class PaginationParams extends QueryParams {
    size;
    page;
    sort;
    direction;
    query;
    filters;

    constructor(obj) {
        super();
        this.size = obj && obj.size || DefaultPagination.pageSize;
        this.page = obj && obj.page || DefaultPagination.pageNumber;
        this.sort = obj && obj.sort || null;
        this.direction = obj && obj.direction || 'ASC';
        this.query = obj && obj.query || '';
        this.filters = obj && obj.filters || null;
    }

    applyToUrl(url) {
        let query = '';
        if (this.size) {
            query = PaginationParams.appendParamToQuery(query, 'size', this.size);
        }
        if (this.page) {
            query = PaginationParams.appendParamToQuery(query, 'page', this.page);
        }
        if (this.query) {
            query = PaginationParams.appendParamToQuery(query, 'search', this.query);
        }
        if (this.sort) {
            if (this.direction) {
                query = PaginationParams.appendParamToQuery(query, 'sort', `${this.sort},${this.direction}`);
            }
            else {
                query = PaginationParams.appendParamToQuery(query, 'sort', this.sort);
            }
        }
        if (this.filters !== null) {
            for (let filter in this.filters) {
                if (this.filters.hasOwnProperty(filter)) {
                    query = PaginationParams.appendParamToQuery(query, filter, this.filters[filter]);
                }
            }
        }
        return `${url}?${query}`;
    }
}


// WEBPACK FOOTER //
// ./src/common/utils/pagination-params.js